import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const PlatformPreviewSection = () => {
  const [activeTab, setActiveTab] = useState('chat');

  const chatMessages = [
    {
      id: 1,
      type: "ai",
      content: "Bonjour ! Je suis votre assistant d\'orientation. Parlez-moi de vos matières préférées à l\'école."
    },
    {
      id: 2,
      type: "user",
      content: "J\'aime beaucoup les mathématiques et la physique. Je suis aussi passionné par l\'informatique."
    },
    {
      id: 3,
      type: "ai",
      content: "Excellent ! Vos intérêts suggèrent une affinité pour les sciences et la technologie. Avez-vous déjà pensé à des carrières dans l\'ingénierie ou l\'informatique ?"
    },
    {
      id: 4,
      type: "user",
      content: "Oui, j'aimerais travailler dans le développement de logiciels ou peut-être devenir ingénieur."
    }
  ];

  const quizQuestions = [
    {
      id: 1,
      question: "Quelle activité vous passionne le plus ?",
      options: [
        "Résoudre des problèmes mathématiques complexes",
        "Créer des œuvres artistiques ou musicales",
        "Aider les autres et travailler en équipe",
        "Analyser des données et faire des recherches"
      ]
    },
    {
      id: 2,
      question: "Dans quel environnement préférez-vous travailler ?",
      options: [
        "Bureau avec ordinateur et technologie",
        "Laboratoire ou atelier pratique",
        "En contact direct avec les gens",
        "En plein air ou sur le terrain"
      ]
    }
  ];

  return (
    <section className="py-12 md:py-16 lg:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-8 md:mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-blue-50 rounded-full mb-4">
            <Icon name="Eye" size={20} color="var(--color-primary)" />
            <span className="text-sm md:text-base font-medium text-blue-700">
              Aperçu de la Plateforme
            </span>
          </div>

          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
            Découvrez Comment Ça Marche
          </h2>

          <p className="text-base md:text-lg text-gray-600 max-w-3xl mx-auto">
            Explorez nos fonctionnalités principales et voyez comment CURSUS Orientation peut transformer votre parcours d'orientation.
          </p>
        </div>

        <div className="bg-gradient-to-br from-blue-50 to-white rounded-2xl p-6 md:p-8 lg:p-12 shadow-xl">
          <div className="flex flex-col sm:flex-row gap-4 mb-8 md:mb-10 overflow-x-auto">
            <button
              onClick={() => setActiveTab('chat')}
              className={`flex items-center gap-2 px-6 py-3 rounded-xl font-medium transition-all duration-300 whitespace-nowrap flex-shrink-0 ${
                activeTab === 'chat' ?'bg-blue-600 text-white shadow-lg' :'bg-white text-gray-700 hover:bg-gray-50'
              }`}
            >
              <Icon name="MessageSquare" size={20} />
              <span>Chat IA</span>
            </button>

            <button
              onClick={() => setActiveTab('quiz')}
              className={`flex items-center gap-2 px-6 py-3 rounded-xl font-medium transition-all duration-300 whitespace-nowrap flex-shrink-0 ${
                activeTab === 'quiz' ?'bg-blue-600 text-white shadow-lg' :'bg-white text-gray-700 hover:bg-gray-50'
              }`}
            >
              <Icon name="ClipboardList" size={20} />
              <span>Quiz Interactif</span>
            </button>
          </div>

          {activeTab === 'chat' && (
            <div className="bg-white rounded-xl p-6 md:p-8 shadow-lg">
              <div className="flex items-center gap-3 mb-6 pb-4 border-b border-gray-200">
                <div className="w-10 h-10 md:w-12 md:h-12 bg-blue-500 rounded-full flex items-center justify-center">
                  <Icon name="Bot" size={24} color="#FFFFFF" />
                </div>
                <div>
                  <div className="text-base md:text-lg font-bold text-gray-900">
                    Assistant IA d'Orientation
                  </div>
                  <div className="text-xs md:text-sm text-green-600 flex items-center gap-1">
                    <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                    En ligne
                  </div>
                </div>
              </div>

              <div className="space-y-4 mb-6 max-h-96 overflow-y-auto">
                {chatMessages?.map((message) => (
                  <div
                    key={message?.id}
                    className={`flex ${message?.type === 'user' ? 'justify-end' : 'justify-start'}`}
                  >
                    <div
                      className={`max-w-[80%] p-4 rounded-2xl ${
                        message?.type === 'user' ?'bg-blue-600 text-white' :'bg-gray-100 text-gray-900'
                      }`}
                    >
                      <p className="text-sm md:text-base leading-relaxed">
                        {message?.content}
                      </p>
                    </div>
                  </div>
                ))}
              </div>

              <div className="flex gap-3">
                <input
                  type="text"
                  placeholder="Tapez votre message..."
                  className="flex-1 px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm md:text-base"
                  disabled
                />
                <Button
                  variant="default"
                  size="default"
                  iconName="Send"
                  disabled
                >
                  Envoyer
                </Button>
              </div>
            </div>
          )}

          {activeTab === 'quiz' && (
            <div className="bg-white rounded-xl p-6 md:p-8 shadow-lg">
              <div className="mb-6">
                <div className="flex items-center justify-between mb-4">
                  <span className="text-sm md:text-base font-medium text-gray-600">
                    Question 1 sur 10
                  </span>
                  <span className="text-sm md:text-base font-medium text-blue-600">
                    10%
                  </span>
                </div>
                <div className="w-full h-2 bg-gray-200 rounded-full overflow-hidden">
                  <div className="h-full bg-blue-600 rounded-full" style={{ width: '10%' }}></div>
                </div>
              </div>

              {quizQuestions?.map((quiz, index) => (
                <div key={quiz?.id} className={index > 0 ? 'mt-8' : ''}>
                  <h3 className="text-lg md:text-xl font-bold text-gray-900 mb-6">
                    {quiz?.question}
                  </h3>

                  <div className="space-y-3">
                    {quiz?.options?.map((option, optionIndex) => (
                      <button
                        key={optionIndex}
                        className="w-full text-left p-4 border-2 border-gray-200 rounded-xl hover:border-blue-500 hover:bg-blue-50 transition-all duration-300 text-sm md:text-base"
                      >
                        <div className="flex items-center gap-3">
                          <div className="w-6 h-6 rounded-full border-2 border-gray-300 flex-shrink-0"></div>
                          <span className="text-gray-700">{option}</span>
                        </div>
                      </button>
                    ))}
                  </div>
                </div>
              ))}

              <div className="mt-8 flex justify-between">
                <Button variant="outline" iconName="ChevronLeft" disabled>
                  Précédent
                </Button>
                <Button variant="default" iconName="ChevronRight" iconPosition="right">
                  Suivant
                </Button>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default PlatformPreviewSection;